import React from 'react'
import { useState, useEffect } from 'react';
import { FaCreditCard, FaMoneyBillWave, FaMapMarkerAlt, FaTag, FaShieldAlt, FaChevronRight, FaPlus } from "react-icons/fa";
import Footer from './component/Footer';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getLocalData } from "./utils/localStorageHelper";
import api from './api';
import { useRazorpay } from 'react-razorpay';
import Swal from "sweetalert2";
import userProfile, { fetchAddressPin, fetchPincodeDetails, postpromoCode, proCodeGet } from "./services/userProfile";
import { useCart } from "./context/CartContext";
import axios from "axios";
import CelebrationOverlay from './utils/CelebrationOverlay';

const Checkout = ({ textToCopy }) => {
  const [isApplied, setIsApplied] = useState(false);
  const [selected, setSelected] = useState("pay");
  const [amount, setAmount] = useState(0);
  const [pincode, setPincode] = useState('');
  const [appliedPromo, setAppliedPromo] = useState(null);
  const [couponCode, setCouponCode] = useState("");
  const [couponMessage, setCouponMessage] = useState("");
  const [shipping, setShipping] = useState(0);
  const [code, setCode] = useState([]);
  const [copied, setCopied] = useState(false);
  const [showPopup, setPopup] = useState(false);
  const { clearCart } = useCart();
  const navigate = useNavigate();
  const { error, isLoading } = useRazorpay();
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [addressData, setAddressData] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const { token, products, singleProduct, singleProductId } = location.state || {};
  const storedData = localStorage.getItem("userData");
  const storedToken = storedData ? JSON.parse(storedData).token : null;
  const [discount, setDiscount] = useState(0);
  const [showCelebration, setShowCelebration] = useState(false);
  const [showOrderPopup, setShowOrderPopup] = useState(false);
  const [orderSuccess, setOrderSuccess] = useState({ message: '', orderId: '', order: null });
  const [isVisible, setIsVisible] = useState(false);

  const emptyAddressForm = {
    fullName: "",
    phone: "",
    pincode: "",
    city: "",
    state: "",
    houseName: "",
    address: "",
    landmark: "",
    addressType: "",
    isDefault: true,
  };
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [addressForm, setAddressForm] = useState(emptyAddressForm);
  const [savingAddress, setSavingAddress] = useState(false);

  const handleClick = (type) => {
    setSelected(type);
    setShipping(type === "pay" ? 0 : 49);
  };

  let cartProducts = [];
  if (products) {
    cartProducts = Array.isArray(products) ? products : [products];

    if (singleProduct === "yes") {
      const localCart = getLocalData("cart") || [];
      cartProducts = cartProducts.map((p) => {
        if ((p.quantity ?? 1) > 1) return p;
        const inCart = localCart.find(
          (c) =>
            c.id === p.id &&
            (c.variant?._id ?? c.variant?.id) === (p.variant?._id ?? p.variant?.id)
        );
        return inCart ? { ...p, quantity: inCart.quantity ?? 1 } : p;
      });
    }
  } else {
    cartProducts = getLocalData("cart") || [];
  }

  const handleApply = async () => {
    try {
      const res = await postpromoCode(couponCode, singleProductId);
      if (res.data?.success) {
        setAppliedPromo(res.data);
        if (res.data?.discountAmount) setAmount(res.data.discountAmount);
        setIsApplied(true);
        setCouponMessage(res.data.message || "Coupon applied successfully!");
        Swal.fire({ icon: "success", title: "Coupon Applied 🎉", text: res.data.message || "Your discount has been applied successfully!", showConfirmButton: false, timer: 2000 });
      }
    } catch (error) {
      Swal.fire({ icon: "error", title: "Invalid Coupon", text: error.response?.data?.message || "Coupon code is required." });
    }
  };

  const handleClear = () => {
    setCouponCode("");
    setAmount(0);
    setIsApplied(false);
    setAppliedPromo(null);
    setCouponMessage("");
  };

  const getPromo = async () => {
    try {
      const res = await proCodeGet();
      setCode(res);
    } catch (error) {
      console.log("error", error.message);
    }
  };
  useEffect(() => { getPromo(); }, []);

  useEffect(() => {
    if (singleProduct === "yes") return;
    const currentCart = getLocalData("cart");
    if (!Array.isArray(currentCart) || currentCart.length === 0) {
      navigate("/", { replace: true });
    }
  }, []);

  const subtotal = cartProducts.reduce(
    (acc, item) => acc + (item.variant?.discountedPrice || 0) * ((item.quantity) ?? 1), 0
  );

  const fetchAddress = async (autoSelectIfNone = false) => {
    try {
      setLoading(true);
      if (!storedToken) return;
      const res = await userProfile(storedToken);
      const addresses = res.data?.user?.addresses || [];
      setAddressData(addresses);

      const savedAddr = localStorage.getItem("selectedDeliveryAddress");

      setSelectedAddressId(prev => {
        if (savedAddr) {
          try {
            const parsed = JSON.parse(savedAddr);
            const found = addresses.find(a => a._id === parsed._id);
            if (found) return found._id;
          } catch (e) {
            console.error("Invalid saved address", e);
          }
        }

        if (prev && addresses.find(a => a._id === prev)) return prev;

        const defaultAddr = addresses.find(addr => addr.isDefault);
        if (defaultAddr) return defaultAddr._id;

        if (autoSelectIfNone && addresses.length > 0) return addresses[0]._id;

        return prev;
      });
    } catch (err) {
      console.error("Failed to fetch profile:", err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { fetchAddress(); }, [storedToken]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
    const toggleVisibility = () => { setIsVisible(window.pageYOffset > 300); };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const handleOpenAddressModal = () => setShowAddressModal(true);

  const handleCloseAddressModal = () => {
    setShowAddressModal(false);
    setAddressForm(emptyAddressForm);
  };

  const lookupPincode = async (pin) => {
    try {
      const response = await axios.get(`https://api.postalpincode.in/pincode/${pin}`);
      const data = response.data?.[0];
      if (data?.Status === "Success" && Array.isArray(data.PostOffice) && data.PostOffice.length > 0) {
        const postOffice = data.PostOffice[0];
        return { city: postOffice.District || "", state: postOffice.State || "" };
      }
      return { city: "", state: "" };
    } catch (error) {
      console.error("Failed to fetch pincode details:", error);
      return { city: "", state: "" };
    }
  };

  const handleAddressChange = async (e) => {
    const { name, type, value, checked } = e.target;
    setAddressForm((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
    if (name === "pincode" && value.length === 6) {
      const details = await lookupPincode(value);
      setAddressForm((prev) => ({ ...prev, pincode: value, city: details.city, state: details.state }));
    }
  };

  const fetchAddressFromCoords = async (lat, lng) => {
    try {
      const apiKey = "AIzaSyCehbIPolbjxmoJobmJv0_8WaAYN504fOE";
      const res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${Number(lat)},${Number(lng)}&key=${apiKey}`);
      const data = await res.json();
      if (data.status === "OK" && data.results.length > 0) {
        const result = data.results[0];
        const components = result.address_components;
        const streetNumber = components.find((c) => c.types.includes("street_number"))?.long_name || "";
        const route = components.find((c) => c.types.includes("route"))?.long_name || "";
        const city = components.find((c) => c.types.includes("locality"))?.long_name || "";
        const state = components.find((c) => c.types.includes("administrative_area_level_1"))?.long_name || "";
        const country = components.find((c) => c.types.includes("country"))?.long_name || "";
        const pincode = components.find((c) => c.types.includes("postal_code"))?.long_name || "";
        const houseName = streetNumber && route ? `${streetNumber}, ${route}` : route || streetNumber || "";
        setAddressForm((prev) => ({
          ...prev,
          latitude: lat,
          longitude: lng,
          address: result.formatted_address || "",
          houseName,
          city,
          state,
          country,
          pincode,
        }));
      }
    } catch (err) {
      console.error("Error fetching address:", err);
    }
  };

  const useMyLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          await fetchAddressFromCoords(latitude, longitude);
        },
        () => { alert("Unable to fetch location. Please enable GPS."); },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
      );
    } else {
      alert("Geolocation is not supported by your browser.");
    }
  };

  const handleAddressSubmit = async (e) => {
    e.preventDefault();
    if (savingAddress) return;
    try {
      const storedUser = localStorage.getItem("userData");
      const userToken = storedUser ? JSON.parse(storedUser).token : null;
      if (!userToken) { alert("User not logged in."); return; }
      if (!addressForm.fullName || !addressForm.phone || !addressForm.address || !addressForm.city || !addressForm.state || !addressForm.houseName || !addressForm.pincode) {
        alert("Please fill all required fields.");
        return;
      }
      setSavingAddress(true);
      const res = await api.post("/user/add-address", addressForm, {
        headers: { Authorization: `Bearer ${userToken}`, "Content-Type": "application/json" },
      });
      if (res.data.addresses || res.data.success) {
        await fetchAddress(true);
        if (Array.isArray(res.data.addresses) && res.data.addresses.length > 0) {
          const newest = res.data.addresses[res.data.addresses.length - 1];
          if (newest?._id) setSelectedAddressId(newest._id);
        }
        handleCloseAddressModal();
        Swal.fire({
          title: "Added!",
          text: "Address added successfully.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (err) {
      console.error("Error saving address:", err);
      Swal.fire({
        title: "Error",
        text: err?.response?.data?.message || "Something went wrong.",
        icon: "error",
        timer: 2500,
        showConfirmButton: false,
      });
    } finally {
      setSavingAddress(false);
    }
  };

  const handleCelebrationDone = () => setShowCelebration(false);

  const findPlacedOrder = async (identifier) => {
    const storedUser = localStorage.getItem("userData");
    const userToken = storedUser ? JSON.parse(storedUser).token : null;
    const res = await api.get("/user/user-orders/ongoing", {
      headers: { Authorization: `Bearer ${userToken}` },
    });
    const list = Array.isArray(res.data.orders) ? res.data.orders : [];
    return list.find((o) => o._id === identifier || o.orderId === identifier) || null;
  };

  const handleOrderOk = async () => {
    setShowOrderPopup(false);
    try {
      const found = await findPlacedOrder(orderSuccess.orderId);
      const placed = found || orderSuccess.order;
      if (placed?._id) {
        navigate(`/order-placed/${placed._id}`, { state: { orders: placed } });
        return;
      }
    } catch (e) {
      console.error(e);
    }
    navigate("/my-orders", { state: { data: orderSuccess } });
  };

  const handlePayment = async () => {
    if (!cartProducts || cartProducts.length === 0) { Swal.fire("⚠️ Your cart is empty!"); return; }
    if (!selectedAddressId) { Swal.fire("⚠️ Please select an address!"); return; }

    const finalAmount = (appliedPromo?.payableAmount || subtotal) + shipping;
    const storedData = localStorage.getItem("userData");
    const token = storedData ? JSON.parse(storedData).token : null;

    const body = {
      addressId: selectedAddressId,
      paymentMethod: selected === "cod" ? "COD" : "UPI",
      shippingCharge: shipping,
      taxAmount: 0,
      singleProductId: singleProductId,
      productData: singleProduct === "yes" ? cartProducts : products,
      appliedCoupon: appliedPromo,
    };

    if (selected === "cod") {
      try {
        let res;
        if (singleProduct === "yes") {
          res = await api.post("/user/buy-now", body, { headers: { Authorization: `Bearer ${token}` } });
        } else {
          res = await api.post("/user/place-order", body, { headers: { Authorization: `Bearer ${token}` } });
          clearCart();
        }
        setShowCelebration(true);
        setOrderSuccess({ message: res.data.message, orderId: res.data.orderId, order: res.data.order || null });
        setTimeout(() => setShowOrderPopup(true), 800);
      } catch (err) {
        Swal.fire(err.response?.data?.message);
      }
      return;
    }

    const options = {
      key: "rzp_live_SQK2pU6L4nZcF4",
      amount: finalAmount * 100,
      currency: "INR",
      name: "Overay",
      description: "Overay Clothing Payment",
      handler: async (response) => {
        try {
          let res;
          if (singleProduct === "yes") {
            res = await api.post("/user/buy-now", body, { headers: { Authorization: `Bearer ${token}` } });
          } else {
            res = await api.post("/user/place-order", body, { headers: { Authorization: `Bearer ${token}` } });
            clearCart();
          }
          setShowCelebration(true);
          setOrderSuccess({ message: "Order Placed Successfully!", orderId: res.data._id, order: res.data.order || null });
          setTimeout(() => setShowOrderPopup(true), 800);
        } catch (err) {
          Swal.fire("⚠️ Something went wrong!", "", "error");
        }
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.on("payment.failed", async function (response) {
      try {
        const failBody = {
          orderId: "68b991318dca89afc2e7b6b1",
          transactionId: "",
          addressId: selectedAddressId,
          paymentMethod: "UPI",
          shippingCharge: 49,
          taxAmount: 0,
          paymentId: response.error.metadata.payment_id,
          paymentStatus: "failed",
        };
        const res = await api.post("/user/razorpay_payment", failBody, { headers: { Authorization: `Bearer ${token}` } });
        Swal.fire({ icon: "warning", title: "Order Placed But Payment Failed!", text: "Order ID: " + res.data.orderId + ". Please complete your payment.", timer: 3000, confirmButtonText: "OK" });
        navigate("/order-placed", { state: { data: res.data } });
      } catch (err) {
        Swal.fire({ icon: "warning", text: err?.response?.data?.message, confirmButtonText: "OK" });
      }
    });
    rzp.open();
  };

  const handlePopupClose = () => {
    setShowOrderPopup(false);
    navigate("/");
  };

  const selectedAddress = addressData?.find(a => a._id === selectedAddressId);

  const couponList = Array.isArray(code)
    ? code
    : Array.isArray(code?.data)
      ? code.data
      : Array.isArray(code?.promoCodes)
        ? code.promoCodes
        : [];

  const handleCopyCoupon = async (value) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      console.error("Copy failed", e);
    }
    setCouponCode(value);
    setPopup(false);
  };

  const displayVal = (v) => {
    if (v === null || v === undefined) return "";
    if (typeof v === "object") return String(v.name ?? v.label ?? v.value ?? "");
    return String(v);
  };

  const appliedDiscount = appliedPromo?.discountAmount || amount || 0;
  const payable = (appliedPromo?.payableAmount || subtotal) + shipping;
  const totalItems = cartProducts.reduce((acc, item) => acc + (item.quantity ?? 1), 0);

  return (
    <>
      <style>{`
        * { box-sizing: border-box; }

        .fk-checkout-wrapper {
          background: #f1f3f6;
          min-height: 100vh;
          font-family: 'Segoe UI', Roboto, sans-serif;
        }

        .fk-checkout-header {
          background: #fff;
          border-bottom: 1px solid #e0e0e0;
          padding: 14px 0;
          margin-bottom: 0;
        }

        .fk-checkout-header .container {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .fk-logo {
          font-size: 22px;
          font-weight: 800;
          color: #d1b559;
          letter-spacing: -0.5px;
        }

        .fk-logo span { color: #ceb256; }

        .fk-header-step {
          font-size: 18px;
          font-weight: 600;
          color: #333;
          margin-left: 8px;
          padding-left: 16px;
          border-left: 2px solid #e0e0e0;
        }

        .fk-checkout-body {
          padding: 20px 0 60px;
        }

        .fk-grid {
          display: grid;
          grid-template-columns: 1fr 380px;
          gap: 16px;
          align-items: start;
        }

        .fk-left { display: flex; flex-direction: column; gap: 12px; }

        .fk-card {
          background: #fff;
          border-radius: 4px;
          box-shadow: 0 1px 4px rgba(0,0,0,0.08);
          overflow: hidden;
        }

        .fk-card-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 18px 20px;
          border-bottom: 1px solid #f0f0f0;
        }

        .fk-card-step {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .fk-step-num {
          width: 26px;
          height: 26px;
          border-radius: 50%;
          background: #d1b559;
          color: #fff;
          font-size: 13px;
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .fk-card-title {
          font-size: 16px;
          font-weight: 700;
          color: #212121;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .fk-header-actions {
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: wrap;
        }

        .fk-change-btn {
          background: none;
          border: 1.5px solid #d1b559;
          color: #d1b559;
          font-size: 13px;
          font-weight: 600;
          padding: 6px 18px;
          border-radius: 3px;
          cursor: pointer;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          gap: 6px;
          text-decoration: none;
        }

        .fk-change-btn:hover {
          background: #d1b559;
          color: #fff;
        }

        .fk-address-body {
          padding: 18px 20px 22px;
        }

        .fk-address-name-row {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 8px;
        }

        .fk-addr-name {
          font-size: 15px;
          font-weight: 700;
          color: #212121;
        }

        .fk-addr-type-badge {
          background: #f0f5ff;
          color: #d1b559;
          font-size: 11px;
          font-weight: 700;
          padding: 2px 8px;
          border-radius: 2px;
          text-transform: uppercase;
          letter-spacing: 0.4px;
        }

        .fk-addr-default-badge {
          background: #e8f5e9;
          color: #388e3c;
          font-size: 11px;
          font-weight: 700;
          padding: 2px 8px;
          border-radius: 2px;
          letter-spacing: 0.4px;
        }

        .fk-addr-phone {
          font-size: 14px;
          color: #555;
          margin-bottom: 6px;
          font-weight: 600;
        }

        .fk-addr-text {
          font-size: 14px;
          color: #666;
          line-height: 1.6;
          max-width: 520px;
        }

        .fk-no-address {
          padding: 30px 20px;
          text-align: center;
          color: #888;
        }

        .fk-no-address svg {
          margin-bottom: 10px;
          opacity: 0.3;
        }

        .fk-no-address .fk-change-btn {
          margin: 12px auto 0;
        }

        .fk-products-body {
          padding: 0;
        }

        .fk-product-row {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 16px 20px;
          border-bottom: 1px solid #f5f5f5;
          transition: background 0.15s;
        }

        .fk-product-row:last-child { border-bottom: none; }
        .fk-product-row:hover { background: #fafafa; }

        .fk-prod-img-wrap {
          position: relative;
          width: 80px;
          height: 96px;
          border-radius: 4px;
          overflow: hidden;
          flex-shrink: 0;
          border: 1px solid #eee;
          background: #f9f9f9;
        }

        .fk-prod-img-wrap img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }

        .fk-qty-badge {
          position: absolute;
          bottom: 4px;
          right: 4px;
          background: rgba(0,0,0,0.65);
          color: #fff;
          font-size: 11px;
          font-weight: 700;
          padding: 1px 6px;
          border-radius: 10px;
        }

        .fk-prod-info { flex: 1; min-width: 0; }

        .fk-prod-name {
          font-size: 14px;
          font-weight: 600;
          color: #212121;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 5px;
          text-decoration: none;
          display: block;
        }

        .fk-prod-name:hover { color: #d1b559; }

        .fk-prod-variant {
          font-size: 12px;
          color: #888;
          margin-bottom: 8px;
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
        }

        .fk-variant-chip {
          background: #f5f5f5;
          padding: 2px 8px;
          border-radius: 2px;
          font-weight: 500;
        }

        .fk-prod-price {
          font-size: 16px;
          font-weight: 700;
          color: #212121;
        }

        .fk-prod-original {
          font-size: 12px;
          color: #999;
          text-decoration: line-through;
          margin-left: 6px;
          font-weight: 400;
        }

        .fk-coupon-body {
          padding: 16px 20px;
        }

        .fk-coupon-row {
          display: flex;
          gap: 10px;
          align-items: center;
        }

        .fk-coupon-input {
          flex: 1;
          height: 44px;
          border: 1.5px solid #ddd;
          border-radius: 3px;
          padding: 0 14px;
          font-size: 14px;
          outline: none;
          transition: border-color 0.2s;
          font-family: inherit;
        }

        .fk-coupon-input:focus { border-color: #d1b559; }

        .fk-coupon-btn {
          height: 44px;
          padding: 0 24px;
          background: #fff;
          border: 1.5px solid #ceb256;
          color: #ceb256;
          font-size: 14px;
          font-weight: 700;
          border-radius: 3px;
          cursor: pointer;
          transition: all 0.2s;
          white-space: nowrap;
        }

        .fk-coupon-btn:hover {
          background: #ceb256;
          color: #fff;
        }

        .fk-view-all-link {
          font-size: 13px;
          color: #d1b559;
          font-weight: 600;
          background: none;
          border: none;
          cursor: pointer;
          padding: 0;
          margin-top: 10px;
          display: inline-flex;
          align-items: center;
          gap: 4px;
          text-decoration: none;
        }

        .fk-coupon-msg {
          margin-top: 10px;
          font-size: 13px;
          font-weight: 600;
        }

        .fk-payment-body {
          padding: 18px 20px;
        }

        .fk-payment-options {
          display: flex;
          flex-direction: column;
          gap: 1px;
          border: 1px solid #e0e0e0;
          border-radius: 4px;
          overflow: hidden;
        }

        .fk-payment-option {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 16px 18px;
          cursor: pointer;
          transition: background 0.15s;
          background: #fff;
          border: none;
          width: 100%;
          text-align: left;
          border-bottom: 1px solid #f0f0f0;
          position: relative;
        }

        .fk-payment-option:last-child { border-bottom: none; }

        .fk-payment-option.active {
          background: #f0f7ff;
        }

        .fk-payment-option:hover:not(.active) { background: #fafafa; }

        .fk-radio {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          border: 2px solid #bbb;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          transition: border-color 0.2s;
        }

        .fk-payment-option.active .fk-radio {
          border-color: #d1b559;
        }

        .fk-radio-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #d1b559;
          display: none;
        }

        .fk-payment-option.active .fk-radio-dot { display: block; }

        .fk-payment-icon {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .fk-payment-icon.pay { background: #e3f2fd; color: #1976d2; }
        .fk-payment-icon.cod { background: #e8f5e9; color: #388e3c; }

        .fk-payment-label { flex: 1; }
        .fk-payment-label strong { font-size: 14px; font-weight: 700; color: #212121; display: block; }
        .fk-payment-label span { font-size: 12px; color: #888; }

        .fk-free-tag {
          background: #e8f5e9;
          color: #388e3c;
          font-size: 11px;
          font-weight: 700;
          padding: 2px 8px;
          border-radius: 2px;
        }

        .fk-right { position: sticky; top: 16px; }

        .fk-summary-card {
          background: #fff;
          border-radius: 4px;
          box-shadow: 0 1px 4px rgba(0,0,0,0.08);
          overflow: hidden;
        }

        .fk-summary-header {
          padding: 16px 20px;
          border-bottom: 1px solid #f0f0f0;
          font-size: 13px;
          font-weight: 700;
          color: #888;
          text-transform: uppercase;
          letter-spacing: 0.8px;
        }

        .fk-summary-body { padding: 0 20px; }

        .fk-summary-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 14px 0;
          border-bottom: 1px solid #f5f5f5;
          font-size: 14px;
          color: #555;
        }

        .fk-summary-row:last-child { border-bottom: none; }

        .fk-summary-row .label { font-weight: 500; }

        .fk-summary-row .val { font-weight: 600; color: #212121; }

        .fk-summary-row .val.green { color: #388e3c; }

        .fk-summary-total {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 16px 20px;
          border-top: 1px solid #e0e0e0;
          font-size: 16px;
          font-weight: 800;
          color: #212121;
        }

        .fk-place-order-btn {
          margin: 0 20px 20px;
          width: calc(100% - 40px);
          height: 52px;
          background: linear-gradient(135deg, #ceb256 0%, #e8c96b 100%);
          color: #fff;
          border: none;
          border-radius: 4px;
          font-size: 16px;
          font-weight: 800;
          cursor: pointer;
          letter-spacing: 0.5px;
          box-shadow: 0 4px 16px rgba(206,178,86,0.4);
          transition: transform 0.15s, box-shadow 0.15s;
        }

        .fk-place-order-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(206,178,86,0.55);
        }

        .fk-security-note {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          padding: 12px 20px;
          font-size: 12px;
          color: #888;
          border-top: 1px solid #f0f0f0;
        }

        .fk-popup-overlay {
          position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
          background: rgba(0,0,0,0.5);
          display: flex; justify-content: center; align-items: center;
          z-index: 10000;
        }

        .fk-popup-box {
          background: #fff;
          border-radius: 8px;
          max-width: 560px;
          width: 92%;
          max-height: 80vh;
          overflow-y: auto;
          box-shadow: 0 8px 32px rgba(0,0,0,0.2);
          position: relative;
        }

        .fk-popup-head {
          padding: 18px 20px;
          border-bottom: 1px solid #f0f0f0;
          font-size: 16px;
          font-weight: 700;
          color: #212121;
          position: sticky;
          top: 0;
          background: #fff;
          z-index: 1;
        }

        .fk-popup-close {
          position: absolute;
          top: 14px; right: 16px;
          background: none; border: none;
          font-size: 20px; cursor: pointer; color: #666;
          line-height: 1;
        }

        .fk-coupon-item {
          padding: 16px 20px;
          border-bottom: 1px solid #f5f5f5;
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .fk-coupon-item:last-child { border-bottom: none; }

        .fk-coupon-code-box {
          border: 1.5px dashed #ceb256;
          padding: 6px 14px;
          border-radius: 4px;
          font-size: 14px;
          font-weight: 700;
          color: #ceb256;
          cursor: pointer;
          white-space: nowrap;
          display: flex;
          align-items: center;
          gap: 8px;
          min-width: 140px;
          justify-content: space-between;
          transition: background 0.15s;
        }

        .fk-coupon-code-box:hover { background: #fffbee; }

        .fk-copy-tag {
          font-size: 11px;
          font-weight: 700;
          color: #d1b559;
          text-transform: uppercase;
        }

        .fk-coupon-info { flex: 1; }
        .fk-coupon-info strong { font-size: 14px; color: #212121; font-weight: 700; display: block; margin-bottom: 4px; }
        .fk-coupon-info p { font-size: 12px; color: #666; margin: 0 0 3px; }
        .fk-coupon-exp { font-size: 11px; color: #999; }

        .fk-order-overlay {
          position: fixed; top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.6);
          display: flex; align-items: center; justify-content: center;
          z-index: 100000;
          animation: backdropIn 0.3s ease;
        }

        .fk-order-popup {
          background: #fff;
          border-radius: 20px;
          padding: 48px 40px 40px;
          max-width: 420px;
          width: 90%;
          text-align: center;
          box-shadow: 0 32px 80px rgba(0,0,0,0.3);
          animation: popupBounce 0.55s cubic-bezier(0.34, 1.56, 0.64, 1);
        }

        .fk-order-emoji {
          font-size: 56px; margin-bottom: 16px; line-height: 1;
          animation: wiggle 0.7s ease 0.2s both; display: block;
        }

        .fk-modal-overlay {
          position: fixed; inset: 0; background: rgba(0,0,0,0.5);
          z-index: 10001; display: flex; align-items: center;
          justify-content: center; padding: 16px;
        }
        .fk-modal-content {
          background: #fff; border-radius: 12px; padding: 28px 24px;
          width: 100%; max-width: 520px; max-height: 90vh;
          overflow-y: auto; box-shadow: 0 8px 32px rgba(0,0,0,0.18);
        }
        .fk-modal-content h3 { font-size: 18px; font-weight: 600; color: #333; margin: 0 0 20px; }
        .fk-form-group { margin-bottom: 14px; display: flex; flex-direction: column; gap: 5px; }
        .fk-form-group label { font-size: 13px; font-weight: 500; color: #555; }
        .fk-form-group input, .fk-form-group select, .fk-form-group textarea {
          padding: 10px 12px; border: 1px solid #ddd; border-radius: 7px;
          font-size: 14px; outline: none; transition: border-color 0.2s;
          width: 100%; box-sizing: border-box; font-family: inherit;
        }
        .fk-form-group input:focus, .fk-form-group select:focus, .fk-form-group textarea:focus {
          border-color: #ceb256; box-shadow: 0 0 0 3px rgba(206,178,86,0.15);
        }
        .fk-form-group textarea { min-height: 80px; resize: vertical; }
        .fk-form-group input[type="checkbox"] { width: auto; margin-right: 8px; }
        .fk-checkbox-label { flex-direction: row; display: flex; align-items: center; font-size: 14px; cursor: pointer; }
        .fk-form-actions { display: flex; gap: 10px; margin-top: 18px; flex-wrap: wrap; }
        .fk-form-actions button {
          flex: 1; padding: 11px; border-radius: 7px; font-size: 14px;
          font-weight: 500; cursor: pointer; border: none; transition: all 0.2s;
        }
        .fk-btn-submit { background: #c4900f; color: #fff; }
        .fk-btn-submit:hover { background: #a87a0c; }
        .fk-btn-submit:disabled { opacity: 0.6; cursor: not-allowed; }
        .fk-btn-cancel { background: #f0f0f0; color: #555; border: 1px solid #ddd !important; }
        .fk-btn-cancel:hover { background: #e0e0e0; }
        .fk-use-location-btn {
          display: inline-flex; align-items: center; gap: 6px;
          background: transparent; border: 1px solid #28a745; color: #28a745;
          border-radius: 6px; padding: 7px 14px; font-size: 13px;
          cursor: pointer; transition: all 0.2s;
        }
        .fk-use-location-btn:hover { background: #28a745; color: #fff; }

        @keyframes popupBounce {
          from { opacity: 0; transform: scale(0.5) translateY(60px); }
          to   { opacity: 1; transform: scale(1) translateY(0); }
        }
        @keyframes backdropIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes wiggle {
          0%   { transform: rotate(0deg) scale(0.3); }
          30%  { transform: rotate(-20deg) scale(1.3); }
          55%  { transform: rotate(12deg) scale(1.0); }
          75%  { transform: rotate(-8deg) scale(1.08); }
          100% { transform: rotate(0deg) scale(1); }
        }

        @media (max-width: 900px) {
          .fk-grid { grid-template-columns: 1fr; }
          .fk-right { position: static; }
        }
      `}</style>

      {showAddressModal && (
        <div
          className="fk-modal-overlay"
          onClick={(e) => { if (e.target.classList.contains("fk-modal-overlay")) handleCloseAddressModal(); }}
        >
          <div className="fk-modal-content">
            <h3>Add New Address</h3>
            <form onSubmit={handleAddressSubmit}>
              <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "12px" }}>
                <button type="button" className="fk-use-location-btn" onClick={useMyLocation}>
                  <FaMapMarkerAlt size={13} /> Use My Location
                </button>
              </div>
              <div className="fk-form-group">
                <label>Full Name *</label>
                <input type="text" name="fullName" value={addressForm.fullName} onChange={handleAddressChange} placeholder="Enter your full name" required />
              </div>
              <div className="fk-form-group">
                <label>Mobile Number *</label>
                <input type="text" name="phone" value={addressForm.phone} onChange={handleAddressChange} placeholder="Enter your mobile number" required />
              </div>
              <div className="fk-form-group">
                <label>Pincode *</label>
                <input type="text" name="pincode" value={addressForm.pincode} onChange={handleAddressChange} placeholder="Enter pincode (auto-fills city & state)" required maxLength={6} />
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                <div className="fk-form-group">
                  <label>City *</label>
                  <input type="text" name="city" value={addressForm.city} onChange={handleAddressChange} placeholder="City" required />
                </div>
                <div className="fk-form-group">
                  <label>State *</label>
                  <input type="text" name="state" value={addressForm.state} onChange={handleAddressChange} placeholder="State" required />
                </div>
              </div>
              <div className="fk-form-group">
                <label>House / Building Name *</label>
                <input type="text" name="houseName" value={addressForm.houseName} onChange={handleAddressChange} placeholder="House no., building name" required />
              </div>
              <div className="fk-form-group">
                <label>Full Address *</label>
                <textarea name="address" value={addressForm.address} onChange={handleAddressChange} placeholder="Street, area, locality" required />
              </div>
              <div className="fk-form-group">
                <label>Landmark</label>
                <input type="text" name="landmark" value={addressForm.landmark} onChange={handleAddressChange} placeholder="Nearby landmark (optional)" />
              </div>
              <div className="fk-form-group">
                <label>Address Type</label>
                <select name="addressType" value={addressForm.addressType} onChange={handleAddressChange}>
                  <option value="">Home</option>
                  <option value="Work">Office</option>
                </select>
              </div>
              <div className="fk-form-group">
                <label className="fk-checkbox-label">
                  <input type="checkbox" name="isDefault" checked={addressForm.isDefault} onChange={handleAddressChange} />
                  Set as Default Address
                </label>
              </div>
              <div className="fk-form-actions">
                <button type="submit" className="fk-btn-submit" disabled={savingAddress}>
                  {savingAddress ? "Saving..." : "Add Address"}
                </button>
                <button type="button" className="fk-btn-cancel" onClick={handleCloseAddressModal}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showCelebration && <CelebrationOverlay onDone={handleCelebrationDone} />}

      {showOrderPopup && (
        <div className="fk-order-overlay">
          <div className="fk-order-popup" style={{ position: 'relative' }}>
            <button onClick={() => handlePopupClose()} style={{ position: 'absolute', top: '16px', right: '16px', background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#888', lineHeight: 1 }}>✕</button>
            <span className="fk-order-emoji">🎉</span>
            <h2 style={{ fontSize: '26px', fontWeight: '800', color: '#1a1a1a', marginBottom: '8px', letterSpacing: '-0.5px' }}>
              Thank you for shopping with Overay!
            </h2>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', backgroundColor: '#e8f5e9', color: '#2e7d32', borderRadius: '999px', padding: '6px 16px', fontSize: '14px', fontWeight: '600', marginBottom: '20px' }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              {orderSuccess.message || "Order Placed Successfully!"}
            </div>
            {orderSuccess.orderId && (
              <p style={{ fontSize: '14px', color: '#666', marginBottom: '24px' }}>
                Order ID: <strong style={{ color: '#212121' }}>{orderSuccess.orderId}</strong>
              </p>
            )}
            <button
              onClick={handleOrderOk}
              style={{ width: '100%', height: '48px', background: 'linear-gradient(135deg, #ceb256 0%, #e8c96b 100%)', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '700', cursor: 'pointer' }}
            >
              View My Orders
            </button>
          </div>
        </div>
      )}

      {showPopup && (
        <div className="fk-popup-overlay" onClick={(e) => { if (e.target.classList.contains('fk-popup-overlay')) setPopup(false); }}>
          <div className="fk-popup-box">
            <div className="fk-popup-head">Available Coupons</div>
            <button className="fk-popup-close" onClick={() => setPopup(false)}>✕</button>
            {couponList.length > 0 ? (
              couponList.map((c, i) => {
                const codeValue = c.code || c.couponCode || c.promoCode || "";
                return (
                  <div className="fk-coupon-item" key={c._id || i}>
                    <div className="fk-coupon-code-box" onClick={() => handleCopyCoupon(codeValue)}>
                      <span>{codeValue}</span>
                      <span className="fk-copy-tag">{copied && couponCode === codeValue ? "Copied" : "Copy"}</span>
                    </div>
                    <div className="fk-coupon-info">
                      <strong>{displayVal(c.title || c.name || codeValue)}</strong>
                      {c.description && <p>{displayVal(c.description)}</p>}
                      {(c.expiryDate || c.expiresAt) && (
                        <span className="fk-coupon-exp">
                          Valid till {new Date(c.expiryDate || c.expiresAt).toLocaleDateString()}
                        </span>
                      )}
                    </div>
                  </div>
                );
              })
            ) : (
              <div style={{ padding: '30px 20px', textAlign: 'center', color: '#888', fontSize: '14px' }}>
                No coupons available right now.
              </div>
            )}
          </div>
        </div>
      )}

      <div className="fk-checkout-wrapper">
        <div className="fk-checkout-header">
          <div className="container">
            <Link to="/" style={{ textDecoration: 'none' }}>
              <span className="fk-logo">Over<span>ay</span></span>
            </Link>
            <span className="fk-header-step">Checkout</span>
          </div>
        </div>

        <div className="fk-checkout-body">
          <div className="container">
            <div className="fk-grid">
              <div className="fk-left">
                <div className="fk-card">
                  <div className="fk-card-header">
                    <div className="fk-card-step">
                      <span className="fk-step-num">1</span>
                      <span className="fk-card-title">Delivery Address</span>
                    </div>
                    <div className="fk-header-actions">
                      <Link to="/my-address" className="fk-change-btn">
                        Change
                      </Link>
                    </div>
                  </div>
                  {loading && !addressData ? (
                    <div className="fk-no-address">Loading address...</div>
                  ) : selectedAddress ? (
                    <div className="fk-address-body">
                      <div className="fk-address-name-row">
                        <span className="fk-addr-name">{selectedAddress.fullName}</span>
                        <span className="fk-addr-type-badge">{selectedAddress.addressType || 'Home'}</span>
                        {selectedAddress.isDefault && <span className="fk-addr-default-badge">DEFAULT</span>}
                      </div>
                      <div className="fk-addr-phone">{selectedAddress.phone}</div>
                      <div className="fk-addr-text">
                        {[selectedAddress.houseName, selectedAddress.address, selectedAddress.landmark ? `Near: ${selectedAddress.landmark}` : null]
                          .filter(Boolean)
                          .join(', ')}
                        <br />
                        {selectedAddress.city}, {selectedAddress.state} - {selectedAddress.pincode}
                      </div>
                    </div>
                  ) : (
                    <div className="fk-no-address">
                      <FaMapMarkerAlt size={36} />
                      <p>No delivery address selected.</p>
                      <button type="button" className="fk-change-btn" onClick={handleOpenAddressModal}>
                        <FaPlus size={11} /> Add Address
                      </button>
                    </div>
                  )}
                </div>

                <div className="fk-card">
                  <div className="fk-card-header">
                    <div className="fk-card-step">
                      <span className="fk-step-num">2</span>
                      <span className="fk-card-title">Order Summary</span>
                    </div>
                  </div>
                  <div className="fk-products-body">
                    {cartProducts.map((item, index) => {
                      const qty = item.quantity ?? 1;
                      const img = item.image || item.images?.[0] || item.variant?.images?.[0] || item.variant?.image;
                      const price = item.variant?.discountedPrice || 0;
                      const original = item.variant?.price || item.variant?.originalPrice;
                      return (
                        <div className="fk-product-row" key={`${item.id || item._id || index}-${item.variant?._id ?? item.variant?.id ?? index}`}>
                          <div className="fk-prod-img-wrap">
                            {img && <img src={typeof img === "object" ? (img.url || img.src || img.value || "") : img} alt={displayVal(item.name || item.title) || "Product"} />}
                            <span className="fk-qty-badge">×{qty}</span>
                          </div>
                          <div className="fk-prod-info">
                            <Link to={`/product/${item.id || item._id}`} className="fk-prod-name">
                              {displayVal(item.name || item.title)}
                            </Link>
                            <div className="fk-prod-variant">
                              {item.variant?.size && <span className="fk-variant-chip">Size: {displayVal(item.variant.size)}</span>}
                              {item.variant?.color && <span className="fk-variant-chip">Color: {displayVal(item.variant.color)}</span>}
                            </div>
                            <div>
                              <span className="fk-prod-price">₹{price * qty}</span>
                              {original && original > price && (
                                <span className="fk-prod-original">₹{original * qty}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="fk-card">
                  <div className="fk-card-header">
                    <div className="fk-card-step">
                      <span className="fk-step-num">3</span>
                      <span className="fk-card-title">Apply Coupon</span>
                    </div>
                    <FaTag color="#ceb256" />
                  </div>
                  <div className="fk-coupon-body">
                    <div className="fk-coupon-row">
                      <input
                        className="fk-coupon-input"
                        type="text"
                        placeholder="Enter coupon code"
                        value={couponCode}
                        onChange={(e) => setCouponCode(e.target.value)}
                        disabled={isApplied}
                      />
                      {isApplied ? (
                        <button className="fk-coupon-btn" onClick={handleClear}>Remove</button>
                      ) : (
                        <button className="fk-coupon-btn" onClick={handleApply}>Apply</button>
                      )}
                    </div>
                    <button type="button" className="fk-view-all-link" onClick={() => setPopup(true)}>
                      View all coupons <FaChevronRight size={10} />
                    </button>
                    {isApplied && couponMessage && (
                      <div className="fk-coupon-msg" style={{ color: '#388e3c' }}>{couponMessage}</div>
                    )}
                  </div>
                </div>

                <div className="fk-card">
                  <div className="fk-card-header">
                    <div className="fk-card-step">
                      <span className="fk-step-num">4</span>
                      <span className="fk-card-title">Payment Options</span>
                    </div>
                  </div>
                  <div className="fk-payment-body">
                    <div className="fk-payment-options">
                      <button
                        type="button"
                        className={`fk-payment-option ${selected === "pay" ? "active" : ""}`}
                        onClick={() => handleClick("pay")}
                      >
                        <span className="fk-radio"><span className="fk-radio-dot" /></span>
                        <span className="fk-payment-icon pay"><FaCreditCard size={16} /></span>
                        <span className="fk-payment-label">
                          <strong>Pay Online</strong>
                          <span>UPI, Cards, Net Banking, Wallets</span>
                        </span>
                        <span className="fk-free-tag">FREE DELIVERY</span>
                      </button>
                      <button
                        type="button"
                        className={`fk-payment-option ${selected === "cod" ? "active" : ""}`}
                        onClick={() => handleClick("cod")}
                      >
                        <span className="fk-radio"><span className="fk-radio-dot" /></span>
                        <span className="fk-payment-icon cod"><FaMoneyBillWave size={16} /></span>
                        <span className="fk-payment-label">
                          <strong>Cash on Delivery</strong>
                          <span>Pay when your order arrives (+₹49 delivery)</span>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="fk-right">
                <div className="fk-summary-card">
                  <div className="fk-summary-header">Price Details</div>
                  <div className="fk-summary-body">
                    <div className="fk-summary-row">
                      <span className="label">Price ({totalItems} {totalItems === 1 ? "item" : "items"})</span>
                      <span className="val">₹{subtotal}</span>
                    </div>
                    {appliedDiscount > 0 && (
                      <div className="fk-summary-row">
                        <span className="label">Coupon Discount</span>
                        <span className="val green">− ₹{appliedDiscount}</span>
                      </div>
                    )}
                    <div className="fk-summary-row">
                      <span className="label">Delivery Charges</span>
                      <span className={`val ${shipping === 0 ? "green" : ""}`}>{shipping === 0 ? "FREE" : `₹${shipping}`}</span>
                    </div>
                  </div>
                  <div className="fk-summary-total">
                    <span>Total Amount</span>
                    <span>₹{payable}</span>
                  </div>
                  <button className="fk-place-order-btn" onClick={handlePayment}>
                    {selected === "cod" ? "PLACE ORDER" : "PAY NOW"}
                  </button>
                  <div className="fk-security-note">
                    <FaShieldAlt size={13} /> Safe and secure payments. 100% authentic products.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        style={{
          position: 'fixed', bottom: '30px', right: '30px', width: '46px', height: '46px',
          borderRadius: '50%', backgroundColor: '#ceb256', color: '#fff', border: 'none',
          zIndex: 1000, cursor: 'pointer', display: isVisible ? 'flex' : 'none',
          alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" height="22" width="22" viewBox="0 0 512 512" fill="none" stroke="currentColor" strokeWidth="48" strokeLinecap="round" strokeLinejoin="round">
          <path d="M112 244l144-144 144 144" />
          <path d="M256 120v292" />
        </svg>
      </button>
    </>
  );
};

export default Checkout;